import { render, staticRenderFns } from "./CallMeBackModal.vue?vue&type=template&id=85fde888&scoped=true&"
import script from "./CallMeBackModal.vue?vue&type=script&lang=js&"
export * from "./CallMeBackModal.vue?vue&type=script&lang=js&"
import style0 from "./CallMeBackModal.vue?vue&type=style&index=0&id=85fde888&scoped=true&lang=scss&"
import style1 from "./CallMeBackModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fde888",
  null
  
)

export default component.exports